import { ToastType } from 'Pages/Dashboard/DashboardContext';
import CampaignLimitToast from 'PhishingManager/components/Toast';
import React, { useState } from 'react';

// eslint-disable-next-line
export interface ModalType<T = any, V = any> {
	name?: T;
	value: V;
}

export const ModalContext = React.createContext<{
	modal: ModalType | null;
	showModal: (value: ModalType) => void;
	hideModal: () => void;
	setToastInfo: (value: ToastType) => void;
}>({
	modal: null,
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	showModal: () => {},
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	hideModal: () => {},
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	setToastInfo: () => {}
});

export const useModal = () => React.useContext(ModalContext);

const toastInitialValue: ToastType = { message: '', type: "warning" }

const ModalContextProvider: React.FC = (props) => {
	const [modal, setModal] = useState<ModalType | null>(null);
	const [toast, setToast] = useState<ToastType>({ ...toastInitialValue });

	const showModal = (value: ModalType) => {
		setModal(value);
	};

	const hideModal = () => {
		setModal(null);
	};

	const setToastInfo = (value: ToastType) => setToast(value);

	return (
		<ModalContext.Provider
			value={{
				modal,
				showModal,
				hideModal,
				setToastInfo
			}}
		>
			{props.children}
			<CampaignLimitToast
				visible={!!toast.message}
				message={toast?.message ?? ''}
				type={toast?.type ?? 'warning'}
				onClose={() => setToastInfo({ ...toastInitialValue })}
			/>
		</ModalContext.Provider>
	);
};

export default ModalContextProvider;
